import React from "react";
import ReactDOM from "react-dom";
import "./static/css/reset.scss";
import "./stores/application.store";
import { AppProvider } from "./stores/application.store";
import App from "./Components/App";

const redirect = ()=>{
  window.location.href= "https://reboot.ynet.co.il/"
}

ReactDOM.render(
  <React.StrictMode>
  {redirect()}
    <AppProvider>
      {/* <App /> */}
    </AppProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
